import React from 'react'

import { COMPONENT_EXTENDER } from 'extender'

const SingleContainerLayout = COMPONENT_EXTENDER('components/layouts/SingleContainerLayout')
const AccountLinking = COMPONENT_EXTENDER('components/core/AccountLinking/AccountLinking-component')

const AccountLinkingPage = () => (
    <SingleContainerLayout linkAccountPage>
        <AccountLinking />
    </SingleContainerLayout>
)

export default AccountLinkingPage
